import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Media} from "../../models/media";
import {environment} from "../../../environments/environment";
import {MediaSelectionModal} from "../../modals/media-selection-modal/media-selection-modal.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'app-media-selection',
    templateUrl: './media-selection.component.html',
    styleUrls: ['./media-selection.component.scss']
})
export class MediaSelectionComponent implements OnInit {

    @Input() media: Array<Media>;
    @Input() mediaId: string;
    @Input() code: string;

    @Output() mediaSelected: EventEmitter<Media> = new EventEmitter<Media>();
    @Output() mediaRemoved: EventEmitter<Media> = new EventEmitter<Media>();

    environment = environment;

    constructor(
        private modalService: NgbModal
    ) {}

    ngOnInit() {
    }

    onShowModal() {
        let modalRef;

        modalRef = this.modalService.open(MediaSelectionModal, {size: 'lg'});
        modalRef.componentInstance.media = this.media;
        modalRef.componentInstance.code = this.code;
        modalRef.result.then(media => {
            this.mediaSelected.emit(media);
        }, dismiss => {});
    }

    getMediaUri() {
        return this.media.find(m => m._id === this.mediaId).uri;
    }

    getMediaFileName() {
        return this.media.find(m => m._id === this.mediaId).uri;
    }

    onRemoveMedia() {
      this.mediaRemoved.emit(this.media.find(m => m._id === this.mediaId))
    }
}
